import moment from "moment";

/** Default compare ranges — Last 7 Days ending yesterday, plus prior equal period */
export const multiCalendarDateRange = {
  selection1: {
    startDate: moment().subtract(7, "days").startOf("day").toDate(),
    endDate: moment().subtract(1, "days").endOf("day").toDate(),
    key: "selection1",
  },
  selection2: {
    startDate: moment().subtract(14, "days").startOf("day").toDate(),
    endDate: moment().subtract(8, "days").endOf("day").toDate(),
    key: "selection2",
  },
};